module.exports = __webpack_public_path__ + "img/lobster.8d8933b0.svg";